import { CLICK, component, demoFile, story, variant, componentWithVariants } from 'system/demo';
import { RelatedConversations, RelatedConversationsAdmin, RelatedConversation } from 'feature/question/related-conversations';
import { t } from 'util/stdtypes';

demoFile('feature/question/related-conversations');

componentWithVariants('RelatedConversations', RelatedConversations, {
    config: {
        relatedConversationsTitle: t('Related conversations')
    },
    features: ['questionrelatedconversations'],
    structureKey: 'question'
}, [
    variant('No Related Conversations (User)', {
        state: {
            collections: {
                relatedConversations: [],
                derived_relatedQuestionPreview: []
            }
        }
    }),
    variant('No Related Conversations (Admin)', {
        state: {
            roles: ['Admin'],
            collections: {
                relatedConversations: [],
                derived_relatedQuestionPreview: []
            }
        }
    }),
    variant('One Related Conversation (User)', {
        state: {
            collections: {
                relatedConversations: [
                    {
                        key: 'question1',
                        text: 'What do you think about climate change?',
                        deleted: false,
                        id: 'question1'
                    }
                ],
                derived_relatedQuestionPreview: [
                    {
                        key: 'question1',
                        commentCount: 5,
                        time: Date.now(),
                        commentPreview: {
                            text: 'I think we need to take immediate action.',
                            time: Date.now(),
                            from: 'user1',
                            fromName: 'John Doe',
                            fromPhoto: null,
                            fromHue: 120
                        },
                        participantCount: 12
                    }
                ]
            }
        }
    }),
    variant('One Related Conversation (Admin)', {
        state: {
            roles: ['Admin'],
            collections: {
                relatedConversations: [
                    {
                        key: 'question1',
                        text: 'What do you think about climate change?',
                        deleted: false,
                        id: 'question1'
                    }
                ],
                derived_relatedQuestionPreview: [
                    {
                        key: 'question1',
                        commentCount: 5,
                        time: Date.now(),
                        commentPreview: {
                            text: 'I think we need to take immediate action.',
                            time: Date.now(),
                            from: 'user1',
                            fromName: 'John Doe',
                            fromPhoto: null,
                            fromHue: 120
                        },
                        participantCount: 12
                    }
                ]
            }
        }
    }, [
        story('Click Select Conversation Button', [
            CLICK('Select conversation')
        ])
    ]),
    variant('Two Related Conversations (User)', {
        state: {
            collections: {
                relatedConversations: [
                    {
                        key: 'question1',
                        text: 'What do you think about climate change?',
                        deleted: false,
                        id: 'question1'
                    },
                    {
                        key: 'question2',
                        text: 'How should we address renewable energy?',
                        deleted: false,
                        id: 'question2'
                    }
                ],
                derived_relatedQuestionPreview: [
                    {
                        key: 'question1',
                        commentCount: 5,
                        time: Date.now(),
                        commentPreview: {
                            text: 'I think we need to take immediate action.',
                            time: Date.now(),
                            from: 'user1',
                            fromName: 'John Doe',
                            fromPhoto: null,
                            fromHue: 120
                        },
                        participantCount: 12
                    },
                    {
                        key: 'question2',
                        commentCount: 3,
                        time: Date.now(),
                        commentPreview: {
                            text: 'Solar and wind power are the future.',
                            time: Date.now(),
                            from: 'user2',
                            fromName: 'Jane Smith',
                            fromPhoto: null,
                            fromHue: 240
                        },
                        participantCount: 8
                    }
                ]
            }
        }
    }),
    variant('Two Related Conversations (Admin)', {
        state: {
            roles: ['Admin'],
            collections: {
                relatedConversations: [
                    {
                        key: 'question1',
                        text: 'What do you think about climate change?',
                        deleted: false,
                        id: 'question1'
                    },
                    {
                        key: 'question2',
                        text: 'How should we address renewable energy?',
                        deleted: false,
                        id: 'question2'
                    }
                ],
                derived_relatedQuestionPreview: [
                    {
                        key: 'question1',
                        commentCount: 5,
                        time: Date.now(),
                        commentPreview: {
                            text: 'I think we need to take immediate action.',
                            time: Date.now(),
                            from: 'user1',
                            fromName: 'John Doe',
                            fromPhoto: null,
                            fromHue: 120
                        },
                        participantCount: 12
                    },
                    {
                        key: 'question2',
                        commentCount: 3,
                        time: Date.now(),
                        commentPreview: {
                            text: 'Solar and wind power are the future.',
                            time: Date.now(),
                            from: 'user2',
                            fromName: 'Jane Smith',
                            fromPhoto: null,
                            fromHue: 240
                        },
                        participantCount: 8
                    }
                ]
            }
        }
    }, [
        story('Click Select Conversation Button', [
            CLICK('Select conversation')
        ])
    ]),
]);

component('RelatedConversationsAdmin', RelatedConversationsAdmin, {
    state: {
        modulePublic: {
            question: {
                'question1': {
                    key: 'question1',
                    question: 'What do you think about climate change?',
                    text: 'What do you think about climate change?',
                    time: Date.now()
                },
                'question2': {
                    key: 'question2',
                    question: 'How should we address renewable energy?',
                    text: 'How should we address renewable energy?',
                    time: Date.now()
                },
                'question3': {
                    key: 'question3',
                    question: 'What is your opinion on electric vehicles?',
                    text: 'What is your opinion on electric vehicles?',
                    time: Date.now()
                }
            }
        },
        collections: {
            relatedConversations: [
                {
                    key: 'question1',
                    text: 'What do you think about climate change?',
                    deleted: false,
                    id: 'question1'
                }
            ]
        }
    }
}, [
    story('Select Multiple Questions', [
        CLICK('How should we address renewable energy?'),
        CLICK('What is your opinion on electric vehicles?')
    ]),
    story('Deselect Question', [
        CLICK('What do you think about climate change?')
    ])
]); 